import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/videos";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {categoryMeta.map((cat) => (
        <Link
          key={cat.key}
          to={`/category/${cat.key}`}
          className="group relative block rounded-lg overflow-hidden bg-background-100 border border-background-200 cursor-pointer"
        >
          <div className="relative h-40 md:h-44 w-full overflow-hidden">
            <img
              src={cat.cover}
              alt={`${cat.name}频道`}
              title={`${cat.name} - 99视频高清影视`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 to-foreground-950/10"></div>
            <span className="absolute top-3 left-3 w-9 h-9 rounded-md bg-background-50/15 backdrop-blur-sm text-background-50 flex items-center justify-center text-xl">
              <i className={cat.icon}></i>
            </span>
            <h3 className="absolute bottom-3 left-3 text-xl font-bold text-background-50">
              {cat.name}
            </h3>
          </div>
          <div className="p-4">
            <p className="text-sm font-medium text-primary-700 mb-1.5">
              {cat.tagline}
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
              {cat.description}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-700 group-hover:gap-2 transition-all">
              进入频道
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}